var _path, _path2, _path3, _path4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgThirtyMinutes(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.9974 1.62399C7.24215 1.62399 5.89745 3.19161 6.16638 4.93068L7.4775 13.4698L6.05765 13.6878L4.74676 5.15021C4.74674 5.15007 4.74679 5.15036 4.74676 5.15021C4.34367 2.54186 6.36038 0.1875 8.9974 0.1875C11.6344 0.1875 13.6512 2.5414 13.2481 5.14974C13.2481 5.1499 13.2481 5.14958 13.2481 5.14974L11.9372 13.6878L10.5173 13.4698L11.8283 4.93144C12.0972 3.19237 10.7527 1.62399 8.9974 1.62399Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.74676 5.15021L6.05765 13.6878L7.4775 13.4698L6.16638 4.93068C5.89745 3.19161 7.24215 1.62399 8.9974 1.62399C10.7527 1.62399 12.0972 3.19237 11.8283 4.93144L10.5173 13.4698L11.9372 13.6878L13.2481 5.14974M4.74676 5.15021C4.74679 5.15036 4.74674 5.15007 4.74676 5.15021ZM4.74676 5.15021C4.34367 2.54186 6.36038 0.1875 8.9974 0.1875C11.6344 0.1875 13.6512 2.5414 13.2481 5.14974M13.2481 5.14974C13.2481 5.14958 13.2481 5.1499 13.2481 5.14974Z",
    stroke: "white",
    strokeWidth: 0.25,
    strokeMiterlimit: 10
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.07031 13.8345C3.07031 13.4378 3.39188 13.1162 3.78856 13.1162C4.18523 13.1162 4.5068 13.4378 4.5068 13.8345V14.657C4.5068 15.5079 5.19662 16.1977 6.04755 16.1977H11.9616C12.8125 16.1977 13.5023 15.5079 13.5023 14.657V13.8345C13.5023 13.4378 13.8239 13.1162 14.2206 13.1162C14.6172 13.1162 14.9388 13.4378 14.9388 13.8345V15.6342C14.9388 16.7388 14.0434 17.6342 12.9388 17.6342H5.07031C3.96574 17.6342 3.07031 16.7388 3.07031 15.6342V13.8345Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.25,
    strokeMiterlimit: 10
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.8132 13.0278C17.8132 13.4245 17.4916 13.7461 17.095 13.7461H0.905744C0.509069 13.7461 0.1875 13.4245 0.1875 13.0278C0.1875 12.6311 0.509069 12.3096 0.905744 12.3096H17.095C17.4916 12.3096 17.8132 12.6311 17.8132 13.0278Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.25,
    strokeMiterlimit: 10
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgThirtyMinutes);
export default __webpack_public_path__ + "static/media/thirtyMinutes.9053be7b24c017132017cb73da096db6.svg";
export { ForwardRef as ReactComponent };